import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { storageKey } from '@/lib/storageKey'

/**
 * i18n setup. Static UI texts, loaded at runtime from `public/locales/{lng}/{ns}.json`.
 *
 * Namespace split: ONE namespace per feature (= per `pages/` folder) + cross-cutting
 * namespaces `common` (buttons, status, table chrome) and `filters` (search/filter UI
 * + the catalog of recurring filter labels like `groups`, usable across all pages).
 * A new feature translation = new `<feature>.json` + register the namespace in `ns` here.
 *
 * All namespaces listed in `ns` are loaded at startup for the active language
 * (small files, internal tool). If the list grows, we can later switch to
 * lazy-per-route — the `useTranslation('<ns>')` call loads a missing
 * namespace on demand anyway.
 */
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    ns: ['common', 'filters', 'errors', 'employees', 'groups', 'sidebar', 'profile', 'header', 'login', 'dashboard', 'permissions', 'company', 'action-modules', 'configuration', 'audit-logs', 'billing', 'wallet', 'wallet-types', 'service-modules', 'service-modules-absence', 'service-modules-timetracking', 'service-modules-calendar', 'service-modules-leaderboard', 'service-modules-personal-documents', 'service-modules-text', 'service-modules-url', 'service-modules-file', 'service-modules-status', 'incentivation', 'action-modules-detail', 'action-modules-wizard', 'notifications', 'shop-modules', 'shop-modules-fullpayout', 'administrators'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      // Order: remembered choice (localStorage) before browser language.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: storageKey('i18nextLng'),
    },
    interpolation: {
      escapeValue: false, // React escapes itself
    },
  })

export default i18n
